import * as React from "react";
const SvgFiRrPear = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pear_svg__a)">
      <path
        fill="#062147"
        d="M23.95 1.316a1 1 0 1 0-1.898-.633c-.229.69-.954 1.464-1.536 1.996a6.9 6.9 0 0 0-3.203-1.553c-2.652-.494-5.309.512-6.933 2.628-.668.87-1.529 1.416-2.425 1.538a9.47 9.47 0 0 0-5.1 2.376c-3.402 3.085-3.675 8.46-.62 12.232 1.986 2.454 4.696 3.943 7.437 4.087q.226.012.451.012c2.208 0 4.234-.863 5.884-2.513a9.45 9.45 0 0 0 2.68-5.287c.16-1.05.654-1.922 1.391-2.453 2.238-1.614 3.31-4.319 2.797-7.06a6.9 6.9 0 0 0-1.033-2.509c.714-.646 1.724-1.71 2.108-2.862zm-5.043 10.81c-1.175.846-1.956 2.185-2.198 3.771a7.47 7.47 0 0 1-2.117 4.176c-1.35 1.35-3.015 2.011-4.816 1.918-2.174-.114-4.356-1.334-5.986-3.348-2.388-2.95-2.208-7.12.41-9.493a7.48 7.48 0 0 1 4.025-1.876c1.421-.194 2.75-1.01 3.741-2.302a5.04 5.04 0 0 1 4.014-1.97q.481 0 .965.09a4.99 4.99 0 0 1 3.963 3.963c.37 1.971-.398 3.914-2 5.07M15.001 13.5a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001m-3 4a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pear_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPear;
